var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[_c('Sidebar',{ref:"sidebar"}),_c('div',{staticClass:"page-wrapper"},[_c('Navbar',{ref:"navbar",on:{"toggle-sidebar":_vm.toggleSidebar}}),_vm._t("default"),_c('Footer')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }